import { XIcon } from "@phosphor-icons/react/dist/csr/X";
import { useCallback } from "react";
import { useNavigate } from "react-router";

import { useHabits } from "@/context/habits-context";

import styles from "./add-more-prompt.module.scss";

export function AddMorePrompt() {
  const navigate = useNavigate();
  const { updateSettings } = useHabits();

  const handleDismiss = useCallback(() => {
    void updateSettings("addMoreDismissed", "true");
  }, [updateSettings]);

  return (
    <div className={styles.prompt} data-testid="add-more-prompt">
      <span className={styles.text}>
        Ready for another?{" "}
        <button type="button" className={styles.link} onClick={() => void navigate("/habits/new")}>
          Add a second habit
        </button>
      </span>
      <button type="button" className={styles.dismiss} onClick={handleDismiss} aria-label="Dismiss">
        <XIcon size={20} aria-hidden="true" />
      </button>
    </div>
  );
}
